import React, { useState } from "react";
import { Drawer, Form, Radio, Select, Button } from "antd";

const TagFiltersDrawer = ({ visible, onClose, onApply, onClear, availableTags = [] }) => {
  const tagOptions = (availableTags || []).map((tag) => ({ value: tag, label: tag }));

  const [form] = Form.useForm();
  const [tagCondition, setTagCondition] = useState(null);

  const showTagSelect = ["is", "is_not", "any_of"].includes(tagCondition);

  const onFinish = (values) => {
    if (showTagSelect && (!values.tag_list || values.tag_list.length === 0)) {
      form.setFields([
        {
          name: "tag_list",
          errors: ["At least one Tag is required"],
        },
      ]);
      return;
    }

    onApply && onApply({ ...values, tag_condition: tagCondition });
  };

  const handleRadioChange = (e) => {
    const value = e.target.value;
    setTagCondition(value);
    if (!["is", "is_not", "any_of"].includes(value)) {
      form.setFieldsValue({ tag_list: [] });
    }
  };

  return (
    <Drawer
      title="Filters"
      placement="right"
      closable
      onClose={onClose}
      visible={visible}
      width={400}
      footer={
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <Button
              onClick={() => {
                form.resetFields();
                setTagCondition(null);
              }}
            >
              Reset form
            </Button>
            <Button
              style={{ marginLeft: 8 }}
              onClick={() => {
                form.resetFields();
                setTagCondition(null);
                onClear && onClear();
              }}
            >
              Clear filters
            </Button>
          </div>

          <div>
            <Button onClick={onClose} style={{ marginRight: 8 }}>
              Cancel
            </Button>
            <Button type="primary" onClick={() => form.submit()}>
              Apply
            </Button>
          </div>
        </div>
      }
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item label={<strong>Tag</strong>}>
          <Radio.Group onChange={handleRadioChange} value={tagCondition} style={{ width: '100%' }}>
            <div style={{ marginBottom: 8 }}>
              <Radio value="is">Is</Radio>
              {tagCondition === "is" && (
                <Form.Item name="tag_list" noStyle>
                  <Select
                    mode="multiple"
                    placeholder="Select tags"
                    options={tagOptions}
                    style={{ display: "block", marginTop: 8 }}
                  />
                </Form.Item>
              )}
            </div>

            <div style={{ marginBottom: 8 }}>
              <Radio value="is_not">Is not</Radio>
              {tagCondition === "is_not" && (
                <Form.Item name="tag_list" noStyle>
                  <Select
                    mode="multiple"
                    placeholder="Select tags"
                    options={tagOptions}
                    style={{ display: "block", marginTop: 8 }}
                  />
                </Form.Item>
              )}
            </div>

            <div style={{ marginBottom: 8 }}>
              <Radio value="is_empty">Is empty</Radio>
            </div>

            <div style={{ marginBottom: 8 }}>
              <Radio value="is_not_empty">Is not empty</Radio>
            </div>

            <div style={{ marginBottom: 8 }}>
              <Radio value="any_of">Any of</Radio>
              {tagCondition === "any_of" && (
                <Form.Item name="tag_list" noStyle>
                  <Select
                    mode="multiple"
                    placeholder="Select tags"
                    options={tagOptions}
                    style={{ display: "block", marginTop: 8 }}
                  />
                </Form.Item>
              )}
            </div>
          </Radio.Group>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default TagFiltersDrawer;
